import { lazy } from 'react';

export const PanelAnimationDelayConfig = lazy(() => import('./PanelAnimationDelayConfig'));
export const PanelColorSettings = lazy(() => import('./PanelColorSettings'));
export const PanelRenderedNumberFormatSettings = lazy(
  () => import('./PanelRenderedNumberFormatSettings'),
);
export const PanelSpringRelatedAnimationConfig = lazy(
  () => import('./PanelSpringRelatedAnimationConfig'),
);
